import { useEffect, useState } from "react";
import WifiOffOutlinedIcon from "@mui/icons-material/WifiOffOutlined";
import "./offlineBanner.css";

// Mounted once at the app root (App.js), outside the router — so it shows on every route
// (Login/GetStarted included, not just the authenticated app) and every platform tier (Mobile/
// Tablet/Desktop; it's just a thin full-width bar, nothing tier-specific needed). `navigator.
// onLine` covers the common case (network adapter down/airplane mode); the "online" event also
// fires on plain Wi-Fi reconnects. Neither ever confirms the connection can actually reach this
// app's own API — that's a deliberately separate, harder problem (real fetches already surface
// their own failures via AlertContext) — this is only the coarse "does the device itself have
// no network at all" signal, kept honest rather than overreaching.
const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return (
    <div
      className={`hf-offline-banner${isOnline ? "" : " visible"}`}
      role="status"
      aria-live="polite"
    >
      <WifiOffOutlinedIcon sx={{ fontSize: 15 }} />
      <span>Nema internet konekcije</span>
    </div>
  );
};

export default OfflineBanner;
